import { render, staticRenderFns } from "./UnfoldMoreHorizontal.vue?vue&type=template&id=2247a3de"
import script from "./UnfoldMoreHorizontal.vue?vue&type=script&lang=js"
export * from "./UnfoldMoreHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports